import { memo } from "react";
import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const difficultyVariants = cva(" ", {
  variants: {
    size: {
      default:
        "[&_.difficulty-marks_div]:w-10 [&_.difficulty-marks_div]:h-1 [&_.difficulty-name]:mb-2",
      sm: "[&_.difficulty-marks_div]:w-3 [&_.difficulty-marks_div]:h-1 [&_.difficulty-name]:mb-1",
    },
    text: {
        default: "text-xs",
        xl: "text-xl"
    }
  },
  defaultVariants: {
    size: "default",
    text: "default"
  },
});

interface DifficultyProps extends VariantProps<typeof difficultyVariants> {
  difficulty: string | number;
}

export const difficultyNames: { [key: number]: string } = {
  1: 'Очень легко',
  2: 'Легко',
  3: 'Нормальный',
  4: 'Сложно',
  5: 'Очень сложно',
} as const;

const GetDifficulty: React.FC<DifficultyProps & { className?: string }> = memo(
  function GetDifficulty({ difficulty, size, text, className }) {
    difficulty = Number(difficulty);
    if (
      isNaN(difficulty) ||
      difficulty < 1 ||
      difficulty > Object.keys(difficultyNames).length
    ) {
      difficulty = 1;
    }

    return (
      <div className={cn(difficultyVariants({ size, className }))}>
        <div className={cn(difficultyVariants({ text, className }) + " difficulty-name")}>
          {difficultyNames[difficulty]}
        </div>
        <div className="difficulty-marks flex gap-1">
          {Object.entries(difficultyNames).map((_, index) => {
            return (
              <div
                key={index}
                className={[
                  difficulty >= index + 1 ? "bg-primary" : "bg-white/25",
                  "rounded-sm",
                ].join(" ")}
              />
            );
          })}
        </div>
      </div>
    );
  }
);

export { GetDifficulty };
